import React, { useRef } from 'react';
import { hasFinePointer, shouldAnimate } from '../../utils/motion';

/**
 * Card that tilts in 3D toward the cursor with a soft glare (mouse only).
 */
export default function TiltCard({ as: Tag = 'div', className = '', children, ...rest }) {
  const ref = useRef(null);
  const enabled = typeof window !== 'undefined' && shouldAnimate() && hasFinePointer();

  const handleMove = (event) => {
    const card = ref.current;
    if (!enabled || !card) return;
    const rect = card.getBoundingClientRect();
    const x = (event.clientX - rect.left) / rect.width;
    const y = (event.clientY - rect.top) / rect.height;
    card.style.setProperty('--tilt-x', `${((0.5 - y) * 8).toFixed(2)}deg`);
    card.style.setProperty('--tilt-y', `${((x - 0.5) * 10).toFixed(2)}deg`);
    card.style.setProperty('--glare-x', `${x * 100}%`);
    card.style.setProperty('--glare-y', `${y * 100}%`);
    card.classList.add('is-tilting');
  };

  const handleLeave = () => {
    const card = ref.current;
    if (!card) return;
    card.style.setProperty('--tilt-x', '0deg');
    card.style.setProperty('--tilt-y', '0deg');
    card.classList.remove('is-tilting');
  };

  return (
    <Tag
      ref={ref}
      className={`home-tilt ${className}`.trim()}
      onPointerMove={enabled ? handleMove : undefined}
      onPointerLeave={enabled ? handleLeave : undefined}
      {...rest}
    >
      {children}
    </Tag>
  );
}
